import "./App.css";
import Routers from "./Routers";
import React, { useState, useContext, createContext } from "react";

export const UserContext = createContext();
export const backendUrl = process.env.REACT_APP_API_URL;
function App() {
  const [user, setUser] = useState({});
  const [age, setAge] = useState(0);
  const [weight, setWeight] = useState(0);
  const [height, setHeight] = useState(0);
  const [gender, setGender] = useState("");
  const [goal, setGoal] = useState(0);
  const [currentRepetition, setCurrentRepetition] = useState(0);
  const [goalrepeticion, setGoalrepeticion] = useState(0);

  return (
    <UserContext.Provider
      value={{
        user,
        setUser,
        age,
        setAge,
        weight,
        setWeight,
        height,
        gender,
        setHeight,
        setGender,
        goal, setGoal,
        currentRepetition, setCurrentRepetition,
        goalrepeticion, setGoalrepeticion
      }}
    >
      <Routers />
    </UserContext.Provider>
  );
}

export default App;
